import { useState } from 'react'
import ChevronDown from '@nv/images/design/chevron-icon'
import clsx from 'clsx'
import { useTranslation } from 'react-i18next'
import styles from './DropdownBanner.module.scss'

const DropdownBanner = ({ status, children, isOpenByDefault }) => {
  const { t } = useTranslation()
  const [isOpen, setIsOpen] = useState(isOpenByDefault)

  const toggleDropdown = () => {
    setIsOpen(!isOpen)
  }

  return (
    <div className={styles['container']}>
      <div
        className={styles['toggle']}
        onClick={toggleDropdown}
        onKeyDown={(e) => {
          if (e.key === 'Enter') toggleDropdown()
        }}
        role='button'
        tabIndex={0}
      >
        <div className={styles['toggle__content']}>
          <div className={clsx(styles['toggle__indicator'], styles[`toggle__indicator--${status.toLowerCase()}`])} />
          <div className={styles['toggle__title']}>{t(`events.status.${status.toLowerCase()}`)}</div>
        </div>

        <ChevronDown
          className={clsx(styles['chevron-icon'], {
            [styles['chevron-icon--open']]: isOpen,
            [styles['chevron-icon--closed']]: !isOpen,
          })}
        />
      </div>

      {isOpen && <div className={styles['content']}>{children}</div>}
    </div>
  )
}

export default DropdownBanner
